import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { MdOutlineEmail } from 'react-icons/md';
import { BsLinkedin } from 'react-icons/bs';
import { FaGithub } from 'react-icons/fa';
import { IoCall } from 'react-icons/io5';
import './contact.css';

const Contact = () => {
  const [message, setMessage] = useState(false);
  const formRef = useRef();
  const handleSubmit = (e) => {
    e.preventDefault();
    setMessage(true);
    emailjs
      .sendForm(
        'service_gxruejf',
        'template_ohhad4g',
        formRef.current,
        'g_PPt_78AJVOyt9mZ'
      )
      .then(
        (result) => {
          console.log(result.text);
        },
        (error) => {
          console.log(error.text);
        }
      );

    e.target.reset();
  };
  return (
    <section id="contact">
      <h5 style={{color:"#6b6767"}}>Get In Touch</h5>
      <h5 style={{color:"#6b6767"}}>
        I do receive your messages and will respond asap if the valid email is
        provided :)
      </h5>
      <h2>Contact Me</h2>
      <div className="container contact__container">
        <div className="contact__options">
          <div className="contact__socials">
            <a href="https://www.linkedin.com/in/vivek-nemade/" target="_blank" rel="noreferrer" ><BsLinkedin /></a>
            <a href="https://github.com/Vivek-Nemade" target="_blank" rel="noreferrer" ><FaGithub /></a>
          </div>
          <article className="contact__option">
            
            <h4 style={{marginBottom:"10px"}}><IoCall /><h5 style={{color:"#6b6767"}}>+91 7276898441</h5></h4>
            <div style={{borderBottom:"1px solid #6b6767",marginBottom:"13px",width:"80%",margin:"auto"}}></div>
            <MdOutlineEmail className="contact__option-icon" />
            <h4>Email</h4>
            <h5 style={{color:"#6b6767"}}>viveknemade11@gmail.com</h5>
            <a href="mailto:viveknemade11@gmail.com" id='smsg'  >Send a message</a>
          </article>
        </div>
        <form ref={formRef} onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Your Full Name"
            name="user_name"
            required
          />
          <input
            type="text"
            placeholder="Your Email"
            name="user_email"
            required
          />
          <textarea
            placeholder="Your message"
            rows="7"
            name="message"
            required
          ></textarea>
          <button type="submit" className="btn btn-primary" id='sendmsg'>
            Send Message
          </button>
          {message && <span>Thanks, I'll reply ASAP :)</span>}
        </form>
      </div>
    </section>
  );
};

export default Contact;
